import { Badge, Box, JsonInput, Stack, Text, Tooltip } from '@mantine/core';

const TextCell = ({ cell, accessorKey }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const value =
        typeof accessorKey === 'function'
            ? accessorKey(rowData)
            : rowData[accessorKey];
    return <Text>{value}</Text>;
};

const TextColumn = ({
    accessorKey,
    accessorFunc,
    header,
    columnProps = {},
}) => ({
    accessorKey: accessorKey,
    accessorFunc: accessorFunc,
    header: header,
    ...columnProps,
    Cell: ({ cell }) => (
        <TextCell
            cell={cell}
            accessorKey={accessorKey || accessorFunc}
        />
    ),
});
export default TextColumn;
